module.exports = __webpack_public_path__ + "static/media/pay_supplier_icon.048097e8.svg";